export function formatDateForAPI(date: any): string {
    if (!date) return '';

    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
    }

    if (date instanceof Date) {
        return date.toISOString().split('T')[0];
    }

    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
        return dateObj.toISOString().split('T')[0];
    }

    return '';
}

export function formatPhoneForAPI(phone: string): string {
    if (!phone) return '';

    const numbersOnly = phone.replace(/\D/g, '');

    if (numbersOnly.length === 11) {
        return numbersOnly;
    }

    if (numbersOnly.length === 10) {
        return '9' + numbersOnly;
    }

    return numbersOnly;
}

export function formatPhoneInternational(phone: string): string {
    if (!phone) return '';

    const numbersOnly = phone.replace(/\D/g, '');

    if (phone.includes('+55')) {
        return phone;
    }

    if (numbersOnly.length === 11) {
        const ddd = numbersOnly.substring(0, 2);
        const number = numbersOnly.substring(2);
        return `+55 ${ddd} ${number.substring(0, 5)}-${number.substring(5)}`;
    }

    if (numbersOnly.length === 10) {
        const ddd = numbersOnly.substring(0, 2);
        const number = numbersOnly.substring(2);
        return `+55 ${ddd} ${number.substring(0, 4)}-${number.substring(4)}`;
    }

    return phone;
}

export function formatDocumentForAPI(document: string): string {
    if (!document) return '';
    return document.replace(/\D/g, '');
}

export function formatCepForAPI(cep: string): string {
    if (!cep) return '';
    return cep.replace(/\D/g, '');
}

export function formatAndValidateExpirationDate(dateNumber: number): string | null {
    if (!dateNumber) {
      return null;
    }

    const dateString = dateNumber.toString().padStart(6, '0');
    
    if (dateString.length !== 6) {
      return null;
    }

    const monthStr = dateString.substring(0, 2);
    const yearStr = dateString.substring(2);

    const month = parseInt(monthStr, 10);
    const year = parseInt(yearStr, 10);

    if (month < 1 || month > 12) {
      console.error('Mês inválido:', month);
      return null;
    }

    const today = new Date();
    const currentYear = today.getFullYear(); 
    const currentMonth = today.getMonth() + 1; 

    if (year < currentYear || (year === currentYear && month < currentMonth)) {
      console.error('Data expirada:', `${monthStr}/${yearStr}`);
      return null;
    }

    return `${monthStr}/${yearStr}`;
}

export function formatBirthDate(isoString: string): string | null {
    if (!isoString) {
      return null;
    }

    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      console.error('String de data ISO inválida:', isoString);
      return null;
    }

    const year = date.getFullYear();

    const month = (date.getMonth() + 1).toString().padStart(2, '0');

    const day = date.getDate().toString().padStart(2, '0');

    return `${year}/${month}/${day}`;
}

export function isOfLegalAge(isoString: string): boolean {
    if (!isoString) {
      return false;
    }

    const birthDate = new Date(isoString);

    if (isNaN(birthDate.getTime())) {
      console.error('Data de nascimento inválida para checagem de idade:', isoString);
      return false;
    }

    const today = new Date();
    
    let age = today.getFullYear() - birthDate.getFullYear();
    
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();


    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--; 
    }

    return age >= 18;
}
